import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { mixpanel } from 'common/helpers'
import actions from 'redux/actions'
import { intlMessageShape, FormattedMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'
import { Image } from 'components/_new/ui'
import Link from 'components/ui/Link/Link'

import messages from './messages'
import s from './NewProductsModal.scss'


class NewProductsModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    buttonMessageTitle: PropTypes.shape(intlMessageShape),
    pictureMessageTitle: PropTypes.shape(intlMessageShape),
    textMessage: PropTypes.shape(intlMessageShape),
    imgSrc: PropTypes.object,
  }

  close = () => {
    const { name, onClose, eventName } = this.props

    mixpanel.track(eventName)
    actions.models.modals.close(name)
    this.updateClosedPopup()

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  updateClosedPopup = () => {
    const { name } = this.props

    actions.models.ui.setClosedPopup(name)
  }

  handleButtonClick = () => {
    const { link } = this.props

    this.close()
    actions.models.router.push(link)
  }

  render() {
    const { name, buttonMessageTitle, link, imgSrc, pictureMessageTitle, textMessage } = this.props

    return (
      <ModalWithActions
        name={name}
        title={messages.title}
        actions={[ {
          key: 'shopNowButton',
          title: buttonMessageTitle,
          onClick: this.handleButtonClick,
          brand: true,
        } ]}
        onClose={this.updateClosedPopup}
      >
        <FormattedMessage className={s.text} {...textMessage} />
        <Link className={s.link} to={link} onClick={this.close}>
          {
            Boolean(pictureMessageTitle) && (
              <FormattedMessage className={s.imageTitle} {...pictureMessageTitle} />
            )
          }
          <Image className={s.image} fullWidth {...imgSrc} />
        </Link>
      </ModalWithActions>
    )
  }
}


export default NewProductsModal
